import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { t } from '@sm/intl';
import { Chip } from '@wds/chip';
import { Box } from '@wds/box';
import { IconInsights } from '@wds/icons';
export const COPY = {
  iconInsights: {
    id: 'OpenEndedCoding.ThemeBadge.iconInsights',
    defaultMessage: 'ML generated',
    description: '[Type: Label][Vis: low] - insights icon to indicate ML generated'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    chip: {
      '& div[class^="wrenchChip"]': {
        backgroundColor: 'white',
        color: theme.palette.text.darkMuted,
        border: `1px solid ${theme.palette.border.muted}`,
        padding: `${theme.spacing[1]}px ${theme.spacing[3]}px`
      }
    }
  };
});
const ThemeBadge = ({
  isGenerated = false,
  theme,
  onClose
}) => {
  const {
    chip
  } = useStyles();
  return _jsx(Box, {
    className: chip,
    children: _jsx(Chip, {
      variant: "dismissible",
      onClick: onClose,
      children: _jsxs(_Fragment, {
        children: [isGenerated && _jsx(IconInsights, {
          title: t(COPY.iconInsights),
          size: "md",
          color: "info"
        }), _jsx(Box, {
          display: "inline",
          ml: 1,
          children: theme
        })]
      })
    })
  });
};
export default ThemeBadge;